var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mt-16",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-app-bar', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-h5 font-weight-bold"
  }, [_vm._v("Materials & Pricing")])], 1), _c('v-card-text', {
    staticClass: "card-text primary--text font-weight-bold px-4 px-sm-12"
  }, [_c('p', {
    staticClass: "text-body-1 primary--text mt-5"
  }, [_vm._v(" Patrons can bring their own compatible, staff approved materials when using the Maker Lab. "), _c('br'), _vm._v(" The library also offers materials required for all of the available equipment. "), _c('br'), _vm._v(" Please refer to the pricing table below for current costs per unit. ")]), _c('v-sheet', {
    staticClass: "mx-auto my-8",
    attrs: {
      "width": "100%",
      "max-width": "500"
    }
  }, [_c('v-data-table', {
    attrs: {
      "dense": "",
      "headers": _vm.tableHeaders,
      "hide-default-footer": "",
      "items": _vm.tableData,
      "items-per-page": 50,
      "item-key": "material"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }